import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// Adicione 'setPersistence' e 'browserLocalPersistence' à importação
import { 
  getAuth, 
  setPersistence, 
  browserLocalPersistence 
} from "firebase/auth";



// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDvExpNNOAUwzKy6ITj-6cXwdzqWxS6Mlc",
  authDomain: "custosagro-409fc.firebaseapp.com",
  projectId: "custosagro-409fc",
  storageBucket: "custosagro-409fc.firebasestorage.app",
  messagingSenderId: "509083919642",
  appId: "1:509083919642:web:152c2f8ec54bde285f38a3",
  measurementId: "G-8SGGNC9BK1",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Linha crucial: Define que a sessão do usuário deve ser salva localmente
// e persistir mesmo que o navegador seja fechado.
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Persistência de login ativada com sucesso.");
  })
  .catch((error) => {
    console.error("Erro ao ativar a persistência de login:", error);
  });

export { db, auth };